<template>
    <div class="card" :class="{'card-selected': selected}">
        <div class="img-wrapper"><img :src="getHeadIcon(anchor.logoPic)" alt=""></div>
        <div class="name-wrapper"><span>{{ anchor.nickname }}</span></div>
        <div class="info">
            <el-tooltip effect="dark" :content="multVoiceAmounts" placement="bottom">
                <img src="../../src/assets/icon-tracks-count.png">
            </el-tooltip>
            <span>{{ anchor.tracksCount}}</span>
            <img src="../../src/assets/icon-spliter.png">
            <el-tooltip effect="dark" :content="multFansAmounts" placement="bottom">
                <img src="../../src/assets/icon-fans-count.png">
            </el-tooltip>
            <span>{{ anchor.fansCount}}</span>
        </div>
        <div class="desc"><span>{{ anchor.personDescribe || $t('word.none') }}</span></div>
    </div>
</template>
<style lang="sass" scoped>
    @import "../../sass/_vars.scss";
    .card {
        height: 280px;
        width: 205px;
        display: inline-block;
        margin: 0 10px;
        background: white;
        div {
            width: 205px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .img-wrapper {
            height: 152px;
            img {
                border-radius: 50%;
                border: 0;
                width: 100px;
                height: 100px;
            }
        }
        .name-wrapper {
            span {
                font-family: "Source Han Sans CN";
                font-size: 14px;
                color: #333333;
                line-height: 14px;
            }
        }
        .info {
            margin-top: 24px;
            margin-bottom: 18px;
            padding: 0 30px;
        }
        .desc {
            padding: 0 15px;
            span {
                font-family: "Source Han Sans CN";
                font-size: 12px;
                color: #999999;
                line-height: 18px;
            }
        }
    }
    .card:hover {
        translate: 0 -2px;
        box-shadow:0px 2px 2px 2px #eee;
        cursor: pointer;
    }
    .card-selected {
        border: 1px solid rgba(252,88,49,0.30);
    }
</style>
<script>
    export default {
        props: {
            selected: {
                type: Boolean,
                default: false
            },
            anchor: {
                type: Object,
                default: {
                    logoPic: '',
                    nickname: '',
                    tracksCount: 0,
                    fansCount: 0,
                    personDescribe: ''
                }
            }
        },
        methods: {
            getHeadIcon(value) {
                let reg = new RegExp('^http://');
                return value? (reg.test(value)? value:this.$store.state.UPLOAD_IMG_HOST + value)
                    : 'http://s1.xmcdn.com/css/img/common/default/user110.jpg';
            }
        },
        computed: {
            // 返回多语言
            multVoiceAmounts: function() {
                return this.$i18n.t('comb.voicesAmounts');
            },
            multFansAmounts:function() {
                return this.$i18n.t('comb.fansAmounts');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AnchorCard.vue?e0d8a88e